import { UnstyledButton, Group, Avatar, Text, Box, Menu, ThemeIcon } from '@mantine/core';
import { IconChevronDown, IconLogout } from '@tabler/icons-react';
import { getUserAvatarColour, getUserInitials } from 'utils/helper';
import { useDispatch } from 'react-redux';
import { logoutUser } from 'modules/Auth/authSlice';
import { createStyles } from '@mantine/emotion';
import { AppConstants } from 'utils/constants';

const useStyles = createStyles((theme, _, u) => ({
    userButton: {
        display: 'block',
        width: '100%',
        padding: theme.spacing.xs,
        borderRadius: theme.radius.sm,
        color: theme.colors.dark[0],
        [u.light]:{
            color:theme.black,
        },
        '&:hover': {
            backgroundColor: theme.colors.dark[6],
            [u.light]:{
                backgroundColor:theme.colors.gray[0],
            },
            
        },
    }
}))

export function User({ data }) {
    
    const dispatch = useDispatch();
    const {classes} = useStyles();
    const onUserClick = () => {
        dispatch(logoutUser(data));
    };

    const userInitials = getUserInitials(data.first, data.last);
    const themeCol = getUserAvatarColour(userInitials);

    return (
        <Group position='center'>
            <Menu width={200} withArrow placement='center'>
                <Menu.Target>
                    <UnstyledButton
                       className={classes.userButton}>
                        {data ? (
                            <Group>
                                <Avatar
                                    src={null}
                                    radius='xl'
                                    size='sm'
                                    color={themeCol}
                                    variant='filled'
                                    alt={`${data.first} ${data.last}`}>
                                    {userInitials.charAt(0)}
                                </Avatar>
                                <Box sx={{ flex: 1 }}>
                                    <Text size='sm' weight={500} style={{ textTransform: 'capitalize' }}>
                                        {data.first} {data.last}
                                    </Text>
                                </Box>
                                <ThemeIcon size={'sm'} variant='default'>
                                    <IconChevronDown stroke={AppConstants.ICON_STROKE_WIDTH} size={AppConstants.ICON_SIZE} />
                                </ThemeIcon>
                            </Group>
                        ) : null}
                    </UnstyledButton>
                </Menu.Target>

                <Menu.Dropdown>
                    <Menu.Item
                        leftSection={<IconLogout size={AppConstants.ICON_SIZE} stroke={AppConstants.ICON_STROKE_WIDTH} />}
                        onClick={() => onUserClick()}
                    >
                        Sign Out
                    </Menu.Item>
                </Menu.Dropdown>
            </Menu>
        </Group>
    );
}
